import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Onboarding } from "@/components/auth/mobile/Onboarding";
import { useAppSession } from "@/providers/AppSessionProvider";
import { useTheme } from "@/providers/ThemeProvider";
import { LanguageSelector } from "@/components/LanguageSelector";

const Tour = () => {
  const navigate = useNavigate();
  const { isAuthenticated } = useAppSession();
  const { theme, setTheme } = useTheme();
  const [showLanguageSelector, setShowLanguageSelector] = useState(true);

  // Force dark mode for tour page
  useEffect(() => {
    const previousTheme = theme;
    if (theme !== 'dark') {
      setTheme('dark');
    }
    return () => {
      // Restore previous theme on unmount
      if (previousTheme !== 'dark') {
        setTheme(previousTheme);
      }
    };
  }, []);

  // Redirect authenticated users to home
  useEffect(() => {
    if (isAuthenticated) {
      navigate("/");
    }
  }, [isAuthenticated, navigate]);

  const handleComplete = () => {
    // After completing tour flow, go to auth page for sign up
    navigate("/auth?signup=true&from=tour");
  };

  const handleSkipToAuth = () => {
    // Skip to auth directly (from sign in button)
    navigate("/auth?from=tour");
  };

  return (
    <>
      {showLanguageSelector && (
        <div className="fixed top-4 right-4 z-50">
          <LanguageSelector />
        </div>
      )}
      <Onboarding
        onComplete={handleComplete}
        onSkipToAuth={handleSkipToAuth}
        startWithTutorial={true}
        onStepChange={(step) => setShowLanguageSelector(step !== 'generate')}
      />
    </>
  );
};

export default Tour;
